/*
 * Guards On Duty: the quote menus' town lists (900+ links) are not printed on
 * every page. They load on demand from sections/quote-areas.liquid (the same
 * section that renders /pages/areas-we-cover) the first time a shopper points
 * at or opens a quote menu, and are kept in sessionStorage for 30 minutes.
 */
(function () {
  if (window.godQuoteAreas) return;
  window.godQuoteAreas = true;

  var KEY = 'god-quote-areas-v1';
  var TTL = 30 * 60 * 1000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var request = null;

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function load() {
    if (request) return request;
    try {
      var cached = JSON.parse(sessionStorage.getItem(KEY));
      if (cached && Date.now() - cached.t < TTL) {
        request = Promise.resolve(parse(cached.h));
        return request;
      }
    } catch (e) {}
    request = fetch(root + '?section_id=quote-areas', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('quote areas ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (html.indexOf('data-qa-menu') === -1) throw new Error('quote areas empty');
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), h: html }));
        } catch (e) {}
        return parse(html);
      });
    request.catch(function () {
      request = null;
    });
    return request;
  }

  function fallback(slot) {
    var li = document.createElement('li');
    var link = document.createElement('a');
    link.href = slot.getAttribute('data-qa-fallback') || '/';
    link.textContent = 'See all towns';
    link.className = slot.hasAttribute('data-qa-drawer')
      ? 'menu-drawer__menu-item link link--text list-menu__item focus-inset'
      : 'mega-menu__link link';
    li.appendChild(link);
    slot.replaceChildren(li);
  }

  function fill(scope) {
    var slots = scope.querySelectorAll('[data-qa-slot]:not([data-qa-filled])');
    if (!slots.length) return;
    load().then(
      function (doc) {
        slots.forEach(function (slot) {
          if (slot.hasAttribute('data-qa-filled')) return;
          var ids = slot.getAttribute('data-qa-slot').split('|');
          var source = doc.querySelector(
            '[data-qa-menu="' + CSS.escape(ids[0]) + '"] [data-qa-province="' + CSS.escape(ids[1]) + '"] ul'
          );
          if (!source) return fallback(slot);
          var drawer = slot.hasAttribute('data-qa-drawer');
          var frag = document.createDocumentFragment();
          source.querySelectorAll('a').forEach(function (a) {
            var li = document.createElement('li');
            var link = document.createElement('a');
            link.href = a.getAttribute('href');
            link.textContent = a.textContent;
            link.className = drawer
              ? 'menu-drawer__menu-item link link--text list-menu__item focus-inset'
              : 'mega-menu__link link';
            if (link.pathname === location.pathname) {
              link.classList.add(drawer ? 'menu-drawer__menu-item--active' : 'mega-menu__link--active');
              link.setAttribute('aria-current', 'page');
            }
            li.appendChild(link);
            frag.appendChild(li);
          });
          slot.replaceChildren(frag);
          slot.setAttribute('data-qa-filled', '');
        });
        // re-run the panel filter if the shopper started typing before the towns arrived
        var filter = scope.querySelector('[data-mega-filter]');
        if (filter && filter.value) filter.dispatchEvent(new Event('input', { bubbles: true }));
      },
      function () {
        slots.forEach(fallback);
      }
    );
  }

  document.querySelectorAll('details[data-qa-lazy]').forEach(function (details) {
    var summary = details.querySelector('summary');
    var go = function () {
      fill(details);
    };
    details.addEventListener('toggle', function () {
      if (details.open) go();
    });
    if (summary) {
      summary.addEventListener('pointerenter', go);
      summary.addEventListener('focus', go);
    }
    if (details.open) go();
  });

  // warm the cache as soon as the mobile menu opens, so provinces are ready when tapped
  var drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      if (drawer.open) load().catch(function () {});
    });
  }
})();
